document.addEventListener('DOMContentLoaded', () => {
  const skuDisplay = document.getElementById('variant-sku');
  const suitableForDisplay = document.getElementById('variant-suitable-for');
  const suitableForWrapper = document.getElementById('variant-suitable-wrapper');
  const variantDataScript = document.getElementById('variant-metafields-json');

  if (!variantDataScript) return;

  const variantData = JSON.parse(variantDataScript.textContent);
  let lastVariantId = null;

  function updateDisplay(variantId) {
    const variant = variantData[variantId];
    if (!variant) {
      console.warn('No metafield data found for variant:', variantId);
      return;
    }

    if (skuDisplay) {
      skuDisplay.textContent = variant.sku || '—';
    }

    if (suitableForDisplay && suitableForWrapper) {
      const value = variant.suitable_for;
    
      let parsed = [];
      try {
        parsed = JSON.parse(value);
      } catch (e) {
        // Not JSON, fallback to string check
        parsed = value ? [value] : [];
      }
    
      if (Array.isArray(parsed) && parsed.length > 0) {
        suitableForDisplay.textContent = parsed.join(', ');
        suitableForWrapper.style.display = '';
      } else {
        suitableForWrapper.style.display = 'none';
      }
    }
  }

  setInterval(() => {
    const script = document.querySelector('.variant-picker__form script[type="application/json"]');
    if (!script) return;

    try {
      const parsed = JSON.parse(script.textContent);
      const variantId = String(parsed.id);

      if (variantId && variantId !== lastVariantId) {
        lastVariantId = variantId;
        updateDisplay(variantId);
      }
    } catch (e) {
      console.warn('Error parsing variant script content:', e);
    }
  }, 300);
});